import React from "react";
import CountUp from "react-countup";
import "./Counter_Component.css";

const Counter_Component = ({ data }) => {
  const counterData = [
    {
      label: "Mentors",
      value: data?.Mentors || "",
      suffix: "+",
    },
    {
      label: "Community Members",
      value: data?.CommunityMembers,
    },
    {
      label: "Years",
      value: data?.Years,
      suffix: "+",
    },
    {
      label: "Events",
      value: data?.events,
      suffix: "+",
    },
  ];


  return (
    <section className="Counter_Component">
      <div className="container">
        <div className="pink_div">
          <div className="counter_div">
            <div className="row">
              {counterData?.map((item, index) => {
                return (
                  <div key={index} className="col-lg-3 col-sm-6">
                    <div className="text_div">
                      <p className="number_text">
                        <CountUp
                          end={item.value}
                          duration={2.5}
                          suffix={item.suffix || ""}
                        />
                      </p>
                      <p className="label_text">{item.label}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter_Component;
